import './tchat.css'
import React, { useContext, useState, useEffect, useRef } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Button, TextField, Typography } from '@material-ui/core';
import { ExpandMore, Chat, Send } from '@material-ui/icons';
import TchatContainer from './components/TchatContainer';
import SocketProvider from 'components/Provider/SocketProvider';
import { sendTchatMsg } from 'services/socketEmitEvent';

function Tchat(props) {
    const tchat_input = useRef();
    const { socket } = useContext(SocketProvider);
    const [ messages, setMessages ] = useState([]);
    const [ width, setWidth ] = useState(100);

    useEffect(()=>{
        socket.on('tchat_newMsg', ({ user, msg })=>{
            setMessages(messages => [...messages, { user, msg }]);
        });
    }, []);

    const sendMsg_handle = () => {
        const msg = tchat_input.current.value;
        if(msg){
            sendTchatMsg(socket, msg);
            tchat_input.current.value = "";
        }

        tchat_input.current.focus();
    }

    const handleOnKeyUp = ({key}) => {
        if(key === 'Enter'){
            sendMsg_handle();
        }
    }

    const onExpandOrCollapse = (object, expanded) => {
        setWidth(expanded ? 400 : 100);
    }

    return (
        <Accordion
            id='tchat_mainContainer' 
            style={{ width: width }}
            onChange={onExpandOrCollapse}
            
        >
            <AccordionSummary
                expandIcon={<ExpandMore color='secondary' />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <Chat />
                <Typography id='tchat_title'>Tchat</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <div style={{ width: '100%' }}>
                    <TchatContainer messages={messages} />
                    <hr/>
                    <div id='tchat_sendContainer'>
                        <TextField 
                            color='secondary' 
                            placeholder='Envoyer un message'
                            autoComplete='off'
                            inputProps={{ id: 'tchat_input' }} 
                            inputRef={tchat_input}
                            style={{flex: '1 1 90%'}}
                            onKeyUp={handleOnKeyUp}
                        />
                        <Button 
                            id='tchat_sendBtton'
                            onClick={sendMsg_handle}
                        >
                            <Send color='secondary' />
                        </Button>
                    </div>
                    
                </div>
            </AccordionDetails>
        </Accordion>
    );
}

export default React.memo(Tchat);